//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { TrackingIdPrefix } from '@models/TrackingId';

export const CollectionsTrackingIdPrefix: TrackingIdPrefix = 'collections-';

export const CollectionsTrackingIds = {
  DELETE_COLLECTION_BUTTON: `${CollectionsTrackingIdPrefix}delete-collection-button`,
  DOWNLOAD_METRICS_BUTTON: `${CollectionsTrackingIdPrefix}download-metrics-button`,
  HIDE_ONE_TIME_ALERT: `${CollectionsTrackingIdPrefix}hide-one-time-alert`,
  LEARN_MORE_ALERT_LINK: `${CollectionsTrackingIdPrefix}learn-more-alert-link`,
  MODAL_DELETE_COLLECTION_BUTTON: `${CollectionsTrackingIdPrefix}modal-delete-collection-button`,
  SAVE_COLLECTION_BUTTON: `${CollectionsTrackingIdPrefix}save-collection-button`,
  UPDATE_COLLECTION_NAME: `${CollectionsTrackingIdPrefix}update-collection-name`,
};

export const MANAGE_COLLECTIONS_PERMISSION = 'library:manage_collections';

export const COLLECTION_METRICS_LEARN_MORE_LINK =
  'https://support.bazaarvoice.com/s/article/Viewing-and-Understanding-Collections-Metrics';

export const STAT_BUBBLE_NAMES = {
  AVG_COMMENTS: 'avgComments',
  AVG_COMPLETION_RATE: 'avgCompletionRate',
  AVG_LIKES: 'avgLikes',
  AVG_REACH: 'avgReach',
  AVG_REPINS: 'avgRepins',
  FOLLOWER_ENGAGEMENT_RATE: 'followerEngagementRate',
  TOTAL_COMMENTS: 'totalComments',
  TOTAL_IMPRESSIONS: 'totalImpressions',
  TOTAL_LIKES: 'totalLikes',
  TOTAL_REPINS: 'totalRepins',
} as const;

export type StatBubbleLabelKey = keyof typeof STAT_BUBBLE_LABELS;

export const STAT_BUBBLE_LABELS = {
  [STAT_BUBBLE_NAMES.AVG_COMMENTS]: 'Average Comments',
  [STAT_BUBBLE_NAMES.AVG_COMPLETION_RATE]: 'Average Completion Rate',
  [STAT_BUBBLE_NAMES.AVG_LIKES]: 'Average Likes',
  [STAT_BUBBLE_NAMES.AVG_REACH]: 'Average Reach',
  [STAT_BUBBLE_NAMES.AVG_REPINS]: 'Average Saves',
  [STAT_BUBBLE_NAMES.FOLLOWER_ENGAGEMENT_RATE]: 'Follower Engagement Rate',
  [STAT_BUBBLE_NAMES.TOTAL_COMMENTS]: 'Comments',
  [STAT_BUBBLE_NAMES.TOTAL_IMPRESSIONS]: 'Total Views',
  [STAT_BUBBLE_NAMES.TOTAL_LIKES]: 'Likes',
  [STAT_BUBBLE_NAMES.TOTAL_REPINS]: 'Saves',
} as const;

export const STAT_BUBBLE_TOOLTIPS = {
  [STAT_BUBBLE_NAMES.AVG_COMMENTS]:
    'Average number of comments per social content posts in this collection.',
  [STAT_BUBBLE_NAMES.AVG_COMPLETION_RATE]: `Average completion rate across the stories in this Collection.
                                                 Completion Rate is calculated as impressions minus exits divided by impressions.`,
  [STAT_BUBBLE_NAMES.AVG_LIKES]:
    'Average number of likes per social content posts in this collection.',
  [STAT_BUBBLE_NAMES.AVG_REACH]:
    'Average number of unique users who have viewed the stories in this Collection.',
  [STAT_BUBBLE_NAMES.AVG_REPINS]:
    'Average number of saves per post in the filtered set of media.',
  [STAT_BUBBLE_NAMES.FOLLOWER_ENGAGEMENT_RATE]: `Average Follower Engagement Rate per post in this collection. Follower Engagement Rate is likes plus comments plus shares plus saves for the social content posts divided by current followers.`,
  [STAT_BUBBLE_NAMES.TOTAL_COMMENTS]:
    'Number of comments associated with the social content posts in this collection.',
  [STAT_BUBBLE_NAMES.TOTAL_IMPRESSIONS]:
    'Sum of views across the stories in this Collection.',
  [STAT_BUBBLE_NAMES.TOTAL_LIKES]:
    'Number of likes associated with the social content posts in this collection.',
  [STAT_BUBBLE_NAMES.TOTAL_REPINS]:
    'Total number of saves per post in the filtered set of media.',
} as const;
